<template>
  <v-container fill-height class="text-center">
    <v-row>
      <v-col style="max-width: 600px" class="mx-auto">
        <v-img
          alt="Error 404"
          contain
          :src="require('@/assets/images/icons/exclamation_mark.png')"
          :height="150"
        />

        <!-- <h1 class="display-2 primary--text">Whoops, 404</h1> -->

        <p class="mt-5 font-weight-bold text-h5">Podany adres nie istnieje.</p>
        <!-- <p class="mt-5">Skontaktuj się z naszym handlowcem lub Biurem Obsługi Klienta.</p> -->
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Error404',
  props: {
    message: {
      type: String,
      default: function () {
        return 'Wystąpił problem'
      }
    }
    // lang: {
    //   type: String,
    //   default: "pl"
    // }
  },
  created() {
    this.$ssrContext && this.$ssrContext.res.status(404)
  }
}
</script>
